import React from 'react';
import { Form, Card, DatePicker } from 'antd';
import { AntdButton, InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const FilterWarrantyComponent = ({ 
    showFilters, 
    onClose, 
    onSearch, 
    onClear, 
    form 
}) => {
    if (!showFilters) return null;

    return (
        <Card style={{ backgroundColor: '#f9f9f9', borderRadius: 8 ,marginTop:'-50px'}}>
            <FontAwesomeIcon icon={faTimes}
                onClick={onClose}
                style={{ 
                    position: 'absolute', 
                    top: 10, 
                    right: 26, 
                    fontSize: 14, 
                    cursor: 'pointer', 
                    color: '#333' 
                }}
            />
            <div style={{ 
                maxHeight: 'calc(100vh - 120px)', 
                overflowY: 'auto', 
                paddingRight: 8, 
                marginTop: 6 
            }}>
                <Form form={form} layout="vertical" onFinish={onSearch}>
                    <Form.Item 
                        name="warrantyStatus" 
                        label="Warranty Status" 
                        style={{ marginBottom: -2}}
                    >
                        <SelectInput
                            allowClear
                            placeholder="Select Warranty Status"
                            options={[
                                { value: 'all', label: 'All Warranties' },
                                { value: 'active', label: 'Active Warranties' },
                                { value: 'expired', label: 'Expired Warranties' },
                            ]}
                        />
                    </Form.Item>
                    
                    <Form.Item name="expiredDateFrom" style={{marginBottom:10}}label="Expired From Date">
                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                    </Form.Item>

                    <Form.Item name="expiredDateTo" style={{marginBottom:10}}label="Expired To Date">
                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                    </Form.Item>
                    
                    <Form.Item name="assetTagId"style={{marginBottom:10}} label="Asset Tag ID">
                        <InputField placeholder="Enter Tag ID" />
                    </Form.Item>

                    <Form.Item name="purchasedFrom"style={{marginBottom:10}}label="Purchased From">
                        <InputField placeholder="Enter Vendor" />
                    </Form.Item>
                    
                    <Form.Item name="productName" label="Product Name">
                        <InputField placeholder="Enter Product Name" />
                    </Form.Item>

                    <div
                        style={{
                            marginBottom: '10px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: 10,
                        }}
                    >
                        <div className="col-md-6 mb-2">
                            <AntdButton 
                                type="primary" 
                                htmlType="submit" 
                                label="Search" 
                            />
                        </div>
                        <div className="col-md-6 mb-2">
                            <AntdButton
                                onClick={onClear}
                                style={{ 
                                    backgroundColor: '#6c757d', 
                                    color: '#fff', 
                                    border: 'none' 
                                }}
                                label="Clear"
                            />
                        </div>
                    </div>
                </Form>
            </div>
        </Card>
    );
};

export default FilterWarrantyComponent;
